import { MdOutlinePolyline } from "react-icons/md";
import { PiPolygonLight } from "react-icons/pi";
import { LiaMapMarkerAltSolid } from "react-icons/lia";
import { PiCircleThin } from "react-icons/pi";
import { CiRoute } from "react-icons/ci";
import { PiPenThin } from "react-icons/pi";
import { PiHighlighterLight } from "react-icons/pi";
import { PiCursorTextThin } from "react-icons/pi";
import { MdOutlineEditNote } from "react-icons/md";
import { CiLink } from "react-icons/ci";
import { CiYoutube } from "react-icons/ci";
import { ElementType } from "~/common/typescript/models/Element";
import { ImMagicWand } from "react-icons/im";

export const ElementPanelUtil = {
  getIcon: (mode: ElementType) => {
    switch (mode) {
      case ElementType.POINT:
        return (<LiaMapMarkerAltSolid />);
      case ElementType.LINESTRING:
        return (<MdOutlinePolyline />);
      case ElementType.POLYGON:
        return (<PiPolygonLight />);
      case ElementType.ROUTE:
        return (<CiRoute />);
      case ElementType.CIRCLE:
        return (<PiCircleThin />);
      case ElementType.SAM:
        return (<ImMagicWand />);
      case ElementType.CHAT_SAM:
        return (<ImMagicWand />);
      case ElementType.MARKER:
        return (<PiPenThin />);
      case ElementType.HIGHLIGHTER:
        return (<PiHighlighterLight />);
      case ElementType.BLOCK_TEXT:
        return (<PiCursorTextThin />);
      case ElementType.NOTE:
        return (<MdOutlineEditNote />);
      case ElementType.LINK:
        return (<CiLink />);
      case ElementType.VIDEO:
        return (<CiYoutube />);
      default:
        return (<LiaMapMarkerAltSolid />);
    }
  }
};
